import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { changeLanguage } from "../../../store/actions/actions";
import { connect } from "react-redux";
import {
  faFile,
  faHome,
  faTh,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import firebase from "../../../firebase";

import { loadState, saveState } from "../../../services/index";

function LeftBar(props) {
  const userDetails = firebase.auth().currentUser;

  const [language, setLanguage] = useState("EN");

  useEffect(() => {
    if (loadState("language")) {
      setLanguage(loadState("language"));
    } else {
      saveState("language", "EN");
    }
  }, [loadState("language")]);

  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState("eventconsole");
  const { id } = useParams();
  const eventSlug = `/project/${id}/`;

  const locations_data = [
    {
      name: `Overview`,
      slug: "dashboard",
      icon: faHome,
      disabled: false,
    },
    {
      name: `Apps`,
      slug: "apps",
      icon: faTh,
      disabled: false,
    },
    {
      name: `Members`,
      slug: "members",
      icon: faUserGraduate,
      disabled: false,
    },
    {
      name: `Documents`,
      slug: "document",
      icon: faFile,
      disabled: false,
    },
    {
      name: `Notes`,
      slug: "notes",
      logo_image: 
      "data:image/png;base64,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",
      disabled: false,
    },
    {
      name: `White Board`,
      slug: "whiteboard",
      logo_image: 
        "data:image/png;base64,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",
      disabled: false,
    }
  ];

  useEffect(() => {
    setCurrentLocation(
      location.pathname.replace(eventSlug, "").replace("/", "")
    );
  }, [location]);

  return (
    <>
      {props.mobile ? (
        <div
          className="container-fluid d-block d-md-none"
          style={{
            backgroundColor: "#17191A",
            position: "fixed",
            zIndex: "10",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        >
          <div className="d-flex justify-content-around">
            {locations_data.map((item, key) => (
              <Link
                key={key}
                className={
                  item.disabled
                    ? "inline-block text-secondary py-3 px-2"
                    : currentLocation === item.slug
                    ? "inline-block text-primary border-bottom border-primary py-3 px-2"
                    : "inline-block text-light py-3 px-2"
                }
                to={
                  !item.disabled &&
                  `${process.env.PUBLIC_URL}${eventSlug}${item.slug}`
                }
              >
                {item.icon && (
                  <FontAwesomeIcon className="mb-0" icon={item.icon} />
                )}
                <span className="smaller d-none">{item.name}</span>
              </Link>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="col-md-1 h-100 pt-5 text-center d-none d-sm-block"
          style={{ borderRight: "#CCCCCC", backgroundColor: "#17191A" }}
        >
          {locations_data.map((item, key) => (
            <Link
              key={key}
              className={
                item.disabled
                  ? "mb-5 text-secondary text-decoration-none"
                  : currentLocation === item.slug
                  ? "mb-5 text-primary text-decoration-none"
                  : "mb-5 text-light text-decoration-none"
              }
              to={
                !item.disabled &&
                `${process.env.PUBLIC_URL}${eventSlug}${item.slug}`
              }
              style={item.disabled ? { cursor: "no-drop" } : {}}
            >
              {item.logo_image ? (
                <img
                  alt=""
                  className="mb-2 shadow-lg rounded-12"
                  src={item.logo_image}
                  style={{ width: "30%" }}
                />
              ) : (
                item.icon && (
                  <FontAwesomeIcon icon={item.icon} style={{ fontSize: 24 }} />
                )
              )}
              <p className="smaller mb-5 small">{item.name}</p>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
  }),
  { changeLanguage }
)(LeftBar);
